/**
 * System-only dropdown options
 *
 * An option flagged `systemOnly` shows the icon in the open list, with the explanation as its
 * tooltip. The chosen value stays plain text, and the flag never reaches the dropdown.
 */

import React, { ReactNode } from 'react';
import { I18n } from 'react-redux-i18n';
import { SystemOnlyIcon, systemOnlyBadgeKeys } from './SystemOnlyBadge';
import Styles from './SystemOnlyBadge.module.css';

export interface SystemOnlyOption {
  content?: ReactNode;
  systemOnly?: boolean;
  text?: ReactNode;
  [key: string]: any;
}

export const markSystemOnlyOptions = <T extends SystemOnlyOption>(
  options: T[]
): T[] =>
  options.map((option) => {
    const { systemOnly, ...rest } = option;
    if (!systemOnly) {
      return option;
    }
    return {
      ...rest,
      content: (
        <span
          className={Styles.optionRow}
          title={`${I18n.t(systemOnlyBadgeKeys.TITLE)}. ${I18n.t(systemOnlyBadgeKeys.BODY)}`}
        >
          {rest.content ?? rest.text}
          <SystemOnlyIcon />
        </span>
      )
    } as T;
  });
